import { createRoute, redirect, Outlet } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { TabLayout } from '@/components/layout/TabLayout'
import { OnboardingGuard } from '@/components/onboarding/OnboardingGuard'

export const authenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_authenticated',
  beforeLoad: ({ context }) => {
    if (!context.isAuthenticated) {
      throw redirect({
        to: '/login',
      })
    }
  },
  component: () => (
    <OnboardingGuard>
      <TabLayout>
        <Outlet />
      </TabLayout>
    </OnboardingGuard>
  ),
})
